/**
 * @generated SignedSource<<2bf8a3cda1d21fb7ccabe3f3051d6e3e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type UserRole = "SUPER" | "ADMIN_ALL" | "ADMIN" | "JUDGE" | "CLIENT" | "SAAS_CLIENT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type FunnelListTab_user$data = {
  readonly role: UserRole;
  readonly " $fragmentType": "FunnelListTab_user";
};
export type FunnelListTab_user = FunnelListTab_user$data;
export type FunnelListTab_user$key = {
  readonly " $data"?: FunnelListTab_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"FunnelListTab_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FunnelListTab_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "632c85550cee16a722cec8bad39dccf3";

export default node;
